












import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import { Product } from '~/modules/catalog/product/types';
import {
  getProductNew,
  getProductBestSeller,
  getProductFurtherReduced,
} from '~/modules/catalog/product/getters/productGetters';

export default defineComponent({
  props: {
    product: {
      type: [Object, null] as PropType<Product | null>,
      default: null,
    },
  },
  setup(props) {
    const tags = computed(() => [
      ...(getProductNew(props.product) ? [{
        label: 'New',
        color: '#fff',
        background: '#B98386',
      }] : []),
      ...(getProductBestSeller(props.product) ? [{
        label: 'Best Seller',
        color: '#fff',
        background: '#B98386',
      }] : []),
      ...(getProductFurtherReduced(props.product) ? [{
        label: 'Further Reduced',
        color: '#fff',
        background: '#B98386',
      }] : []),
    ]);

    return {
      tags,
    };
  },
});
